import React from "react";
import { LIMIT_EXCEED } from "../../actions/actionTypes";
import { useDispatch, useSelector } from "react-redux";
import { useFileRemoval } from "../../helpers/useFileRemoval";
import ErrorPopup from "./ErrorPopup";

const LimitExceed = ({
  allFiles,
  setAllFiles,
  allProcessedFiles,
  setAllProcessedFiles
}) => {
  const dispatch = useDispatch();

  const imageUpload = useSelector((state) => state.upload.imageUpload);

  const { handleDelete, redirectToUpload } = useFileRemoval({
    allFiles,
    setAllFiles,
    allProcessedFiles,
    setAllProcessedFiles,
  });

  const onTryAgain = () => {
    dispatch({ type: LIMIT_EXCEED, payload: false });
    handleDelete();
    redirectToUpload();
  };

  return (
    <ErrorPopup onTryAgain={onTryAgain}>
      <div className="upload-title-text">
        Upload failed!
      </div>
      <div className="upload-content-text">
        {imageUpload ? "The Image limit exceeded." : "The PDF File limit exceeded."}
      </div>
      <div className="upload-content-text">
        {" "}
        {imageUpload ? "The Image size should not exceed 5MB!" : "The PDF File size should not exceed 50MB!"}
      </div>
    </ErrorPopup>
  );
};

export default LimitExceed;
